import { useCallback } from 'react';
import { FilterItem } from './FilterItem';
import styles from './filterItem.module.scss'
import { GenericColumnModel, OrFilterType } from '../../models';
import { Translation } from 'components/Translations/Translation';

export const useGetOrFiltersCallback = (columns: GenericColumnModel[]) => {
	return useCallback(
		(filters: OrFilterType[]) => {
			const content: React.ReactNode[] = [];
			for (let i = 0; i < filters.length; i++) {
				const filter = filters[i];

				content.push(<FilterItem key={i} filter={filter} columns={columns} />);
				if (i < filters.length - 1) {
					content.push(<span className={styles.conjunction}>
						<Translation i18n={'i18n.label.filter.or'} />
					</span>);
				}
			}

			content.unshift(<span>(</span>);
			content.push(<span>)</span>);
			return content;
		},
		[columns]
	)
}
